module.exports = __webpack_public_path__ + "static/media/volkron.08d49a87.svg";